import { includes } from 'lodash';

import { TRANSFER_TYPE } from '@app/shared/types/entities/transfer/transfer.enums';

const isEventType = (transferType: TRANSFER_TYPE): boolean => {
  const eventTypes = [
    TRANSFER_TYPE.PRE_EVENT_TRANSFER,
    TRANSFER_TYPE.DURING_EVENT_TRANSFER,
  ];

  return includes(eventTypes, transferType);
};

const isOutsideOfEventTransfer = (transferType: TRANSFER_TYPE): boolean => {
  return !isEventType(transferType);
};

export { isEventType, isOutsideOfEventTransfer };
